import { render, staticRenderFns } from "./PreviewLinkShare.vue?vue&type=template&id=ddf9aa04&scoped=true"
import script from "./PreviewLinkShare.vue?vue&type=script&lang=js"
export * from "./PreviewLinkShare.vue?vue&type=script&lang=js"
import style0 from "./PreviewLinkShare.vue?vue&type=style&index=0&id=ddf9aa04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf9aa04",
  null
  
)

export default component.exports